import { storage } from '~/lib/storage';

const RasylvaApi = {
  install(Vue) {
    const isValidSoftwareToken = (softwareToken) => {
      softwareToken && softwareToken.status === 'active' && new Date(softwareToken.expired_at) > new Date();
    };
    const serialize = (obj) => {
      var str = [];
      for (var p in obj)
        if (Object.prototype.hasOwnProperty.call(obj, p)) {
          str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
      return str.join('&');
    };
    Vue.prototype.$rasylvaApi = {
      jwt: null,
      softwareToken: null,
      fetcher: null,
      async init(isPublic = false) {
        // Migrate to IndexedDB
        const isUsingLocalStorage = window.localStorage.getItem('inventum-app-token');
        if (isUsingLocalStorage) {
          this.jwt = JSON.parse(localStorage.getItem('rasylva-jwt')) || {};
          this.softwareToken = JSON.parse(localStorage.getItem('inventum-app-token')) || null;
          await storage.setItemMany([
            ['rasylva-jwt', this.jwt],
            ['inventum-app-token', this.softwareToken],
          ]);
          localStorage.removeItem('rasylva-jwt');
          localStorage.removeItem('inventum-app-token');
        } else {
          this.jwt = (await storage.getItem('rasylva-jwt')) || null;
          this.softwareToken = (await storage.getItem('inventum-app-token')) || null;
        }
        this.fetcher = async (url, { method = 'GET', headers = {}, body } = {}) => {
          let jwt = null;
          if (headers['Authorization-Type'] === 'software-token' && isValidSoftwareToken(this.softwareToken)) {
            jwt = this.softwareToken;
          } else {
            jwt = this.jwt;
            headers['Authorization-Type'] = 'jwt-token';
          }
          if (isPublic) {
            headers['Authorization-Type'] = 'public-token';
          }
          if (!jwt && !isPublic) throw new Error('Unauthorized. Pelase re-login.');
          const options = {
            method,
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'credentials': 'same-origin',
              'X-Requested-With': 'XMLHttpRequest',
              ...(jwt ? { Authorization: `brearer ${jwt.token}` } : {}),
              ...headers,
            },
          };
          if (body) options.body = JSON.stringify(body);
          const response = await fetch(`/api${url}`, options);
          const json = await response.json();
          return json;
        };
      },
      async setJwt(jwt) {
        this.jwt = jwt;
        try {
          await storage.setItem('rasylva-jwt', jwt);
        } catch (e) {
          console.warn(e);
        }
      },
      getGoogleToken() {
        return this.jwt?.google || {};
      },
      getUser() {
        return this.jwt?.user || {};
      },
      isLoggedIn() {
        const isUserExist = !!this.jwt?.user?.id;
        const isValidToken = !!this.jwt?.exp && new Date(this.jwt.exp) > new Date();
        return isUserExist && (isValidToken || isValidSoftwareToken(this.softwareToken));
      },
      async login(idToken) {
        const options = {
          method: 'POST',
          body: JSON.stringify({ id_token: idToken }),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'credentials': 'same-origin',
            'X-Requested-With': 'XMLHttpRequest',
          },
        };
        const response = await fetch('/api/auth/google', options);
        const data = await response.json();
        if (!data) throw new Error('Unauthorized');
        const jwt = { ...data, google: { ...idToken } };
        await this.setJwt(jwt);
        return jwt;
      },
      async logout() {
        await storage.removeItem('rasylva-jwt');
        await storage.removeItem('inventum-app-token');
        if (navigator.credentials?.preventSilentAccess) {
          navigator.credentials.preventSilentAccess();
        }
        window.location.reload();
      },
      get(url, { headers = {}, body } = {}) {
        const options = { method: 'GET', headers };
        const params = body ? `?${serialize(body)}` : '';
        return this.fetcher(`${url}${params}`, options);
      },
      post(url, { headers = {}, body } = {}) {
        const options = { method: 'POST', headers, body };
        return this.fetcher(url, options);
      },
      patch(url, { headers = {}, body } = {}) {
        const options = { method: 'PATCH', headers, body };
        return this.fetcher(url, options);
      },
      put(url, { headers = {}, body } = {}) {
        const options = { method: 'PUT', headers, body };
        return this.fetcher(url, options);
      },
      delete(url, { headers = {}, body } = {}) {
        const options = { method: 'DELETE', headers, body };
        return this.fetcher(url, options);
      },
    };
  },
};

export default RasylvaApi;
